import React, {useCallback} from "react";
import useForm from "rc-form-hooks";
import Input from "../../components/inputItem";
import {setUserNickName} from "../../service";
import {useHistory} from "react-router-dom";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";


function UserInfoInput() {

    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        nickname: string
    }>();

    const userData = useUserInfo();

    const loading = useLoading();

    const his = useHistory();

    const dispatch = useDispatch()

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {
                if (userData && typeof values.nickname === 'string') {
                    setUserNickName({
                        userId: userData.id,
                        nickname: values.nickname
                    }).then(res => {
                        if (res.code === 1) {
                            loading.showSuccess()
                            dispatch(userInfoAction(Object.assign({},userData,{nickName:values.nickname})))
                            // setUserStorage('nickName',values.nickname)
                            his.goBack()
                        }else{
                            loading.showError()
                        }
                    })
                }

            })
            .catch(e => console.error(e.message));
    }, [values])

    return <div className="user-nickname">
        <form onSubmit={handleSubmit}>
            {
                getFieldDecorator('nickname', {
                    rules: [{required: true, message: '请输入昵称'}],
                    initialValue: userData?.nickName
                })(<Input label='昵称' type={'text'} placeholder='请输入昵称'
                          extraClass={['no-border-top', 'fill-width']}
                          clear/>)
            }
            {
                userData && <button type={'submit'} className="common-btn submit">确认</button>
            }

        </form>
    </div>
}

export default UserInfoInput;
